import {
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
} from '@kanda-libs/ks-design-library';

import { Content } from '../components';

const ViewComponent = ({}) => (
  <DesktopLayoutBoxed>
    <DesktopLayoutBoxedContent>
      <Content />
    </DesktopLayoutBoxedContent>
  </DesktopLayoutBoxed>
);

ViewComponent.displayName = 'Expired-Desktop-view';

export default ViewComponent;
